import React, {FC, memo} from "react";
import {NotificationsProps} from "./Notification-types";
import {Button, Message, Root, Title} from "./Notification-styles";
import toast from "react-hot-toast";


const Notification: FC<NotificationsProps> = memo((props) => {
    const {instance, title, text} = props;

    if (!text) {
        return null;
    }

    const messages = typeof text === 'string'
        ? [text]
        : text;

    return (
        <Root onClick={() => toast.remove(instance.id)}>

            {
                title &&
                <Title>{title}</Title>
            }

            {
                messages.map((message, index) => (
                    <Message key={index}>{message}</Message>
                ))
            }

            <Button />

        </Root>
    )
});

export default Notification;
